import { render, staticRenderFns } from "./ColorTool.vue?vue&type=template&id=76db9698&scoped=true&"
import script from "./ColorTool.vue?vue&type=script&lang=js&"
export * from "./ColorTool.vue?vue&type=script&lang=js&"
import style0 from "./ColorTool.vue?vue&type=style&index=0&id=76db9698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db9698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VFlex,VLayout,VSelect,VTextarea})
